import { TAvailableConfigValues } from '@customTypes/common';

export interface IDebuggerConfig {
  enableRemoteDebugging: boolean;
  debuggerUrl: string;
  maxWSConnectionRetries: number;
  modulesStateGatheringPeriod: number;
  enableLifecycleEvents: boolean;
}

export const defaultDebuggerConfig: IDebuggerConfig = {
  enableRemoteDebugging: false,
  debuggerUrl: 'wss://doppio-player-debug.stripcdn.com',
  maxWSConnectionRetries: 3,
  modulesStateGatheringPeriod: 1000,
  enableLifecycleEvents: true,
};

export const availableDebuggerConfigValues: TAvailableConfigValues<IDebuggerConfig> = {};
